var _excluded = ["children", "sizeVariant", "hideLabel", "className", "style", "tooltip", "tooltipProps", "disabled", "dangerouslySetClassNames"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled from "styled-components";
import Text from "../Text";
import Tooltip from "../Tooltip";
import forwardRef from "../../private/forwardRef";
import { pxToRem } from "../../private/helpers";
var VisuallyHiddenLabel = styled.label.withConfig({
  displayName: "Label__VisuallyHiddenLabel",
  componentId: "sc-gy7sv-0"
})(["border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"]);
var VisibleLabel = styled(Text).withConfig({
  displayName: "Label__VisibleLabel",
  componentId: "sc-gy7sv-1"
})(["color:", ";"], _ref => {
  var {
    $disabled,
    theme
  } = _ref;
  return $disabled && theme.palette.textDisabled;
});
var StyledTooltip = styled(Tooltip).withConfig({
  displayName: "Label__StyledTooltip",
  componentId: "sc-gy7sv-2"
})(["margin-left:", ";vertical-align:bottom;"], pxToRem(2));
/**
 * Labels represent a caption for an item in a user interface.
 *
 * This component is not required for any of the standard Construct Kit form components
 * as they all have a label built in. This is primarily used for form elements that don't
 * exist in Construct Kit.
 *
 * @see [Label documentation](https://construct-kit.reainternal.net/components/web/core/label)
 */
var Label = forwardRef((_ref2, ref) => {
  var {
      children,
      sizeVariant = "large",
      hideLabel = false,
      className,
      style,
      tooltip,
      tooltipProps,
      disabled = false,
      dangerouslySetClassNames
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return hideLabel ? /*#__PURE__*/React.createElement(VisuallyHiddenLabel, _extends({
    ref: ref
  }, props), children) : /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(VisibleLabel, _extends({
    forwardedAs: "label",
    ref: ref,
    variant: sizeVariant === "large" ? "subtitle01" : "subtitle02",
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.label,
    $disabled: disabled
  }, props), children), tooltip && /*#__PURE__*/React.createElement(StyledTooltip, _extends({
    placement: "top",
    sizeVariant: sizeVariant === "large" ? "medium" : sizeVariant,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.tooltip,
    dangerouslySetClassNames: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.tooltipClassNames
  }, tooltipProps), tooltip));
});
Label.displayName = "Label";

// This is only used internally
export { VisuallyHiddenLabel };
export default Label;